import React from "react";
import FormGroup from "../FormGroup";
import { FieldGrid } from "../FieldGrid";
import {
  QuestionaireSecondaryPassedThroughProps,
  QuestionType,
} from "../types";

const QuestionsSecondary = (props: QuestionaireSecondaryPassedThroughProps) => {
  const { questionsSecondary, setQuestionsSecondary } = props;

  return (
    <FieldGrid>
      {questionsSecondary &&
        questionsSecondary.map(
          ({
            displayValue,
            value,
            id,
            hint,
            required,
            type,
            placeholder,
            invalid,
            feedbackInvalid,
            wide,
          }: QuestionType) => {
            return (
              <FormGroup
                key={id}
                value={value}
                id={id}
                displayValue={displayValue}
                hint={hint}
                required={required}
                type={type}
                placeholder={placeholder}
                feedbackInvalid={feedbackInvalid}
                invalid={invalid}
                wide={wide}
                onChangeEvent={(evnt: any) => {
                  const { value } = evnt.target;
                  const questionsWithValue: QuestionType[] =
                    questionsSecondary.map((question) => {
                      const { id: qId } = question;
                      const sameQuestion = qId === id;
                      if (sameQuestion) {
                        question.value = value;
                      }
                      return question;
                    });
                  setQuestionsSecondary(questionsWithValue);
                }}
              />
            );
          }
        )}
    </FieldGrid>
  );
};

export default QuestionsSecondary;
